export default __webpack_public_path__ + "static/media/vt04.66e2cade.jpg";